const isPdf = (href: string) => {
  try {
    return !!(href && new URL(href).pathname.match('.+.pdf$')?.length);
  } catch (e) {
    return false;
  }
};

export default isPdf;
